// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorPage_wrapper__1VzQp","title":"ErrorPage_title__iktBX","errorCode":"ErrorPage_errorCode__xOH41"};